import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from '@mds/authentication';
import { catchError, EMPTY, Observable, throwError } from 'rxjs';
import { ErrorCodes } from '../models/errors.model';
import { ErrorService } from '../services/error.service';

@Injectable()
export class ReAuthenticationInterceptor implements HttpInterceptor {
  constructor(
    private readonly injector: Injector,
    private readonly router: Router,
    private readonly errorService: ErrorService
  ) {}

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(req).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 && this.errorService.getErrorCode(error) === ErrorCodes.ReAuth.ReAuthenticate) {
          const authService = this.injector.get(AuthenticationService);
          authService.reAuthenticate(this.router.routerState.snapshot.url);
          return EMPTY;
        }
        return throwError(() => error);
      })
    );
  }
}
